/**
import all locale translation from different module
and export from this file.
 **/
import homepage from '@/Homepage/langs/en_us'
import auth from '@/Auth/langs/en_us'
import error from '@/ErrorPage/langs/en_us'
import fitComponents from '@/components/langs/en_us'
import validation from '@/Validation/langs/en_us'

import product from '@/Product/langs/en_us'
import cart from '@/Cart/langs/en_us'
import account from '@/Account/langs/en_us'
import payment from '@/Payment/langs/en_us'

export default {
  hm: 'Home',
  general: {
    batchSelect: 'Select (Multiple)',
    selectable: 'Select',
    submit: 'Submit',
    add: 'Add',
    remove: 'Remove',
    logout: 'Logout',
    language: 'System Language',
    updateSuccess: 'Update Success.',
    updateError: 'Update Failed. Please Try Again',
    deleteSuccess: 'Delete Success.',
    selectDate: 'Please selecte date',
    autoSearchText: 'Sorry, no match options.',
    ok: 'OK',
    cancel: 'Cancel',
    confirm: 'Confirm',
    notification: 'Notification',
    message: 'Message',
    yes: 'Yes',
    no: 'No',
    save: 'Save',
    create: 'Create',
    edit: 'Edit',
    status: 'Status',
    all: 'All',
    pagination: {
      perPage: 'Items Per Page',
      items: 'Page {page} / Total {total} items'
    },
    action: 'Action',

    fromDate: 'Date From',
    toDate: 'Date To',
    startDate: 'Start Date',
    endDate: 'End Date',
    clearFilter: 'Clear Filter',

    search: 'Search Keywords',
    total: 'Total',
    records: 'Records',
    all: 'All',
    more: 'More',
    date: 'Date',
    perPage: 'Per Page',

    M: 'Male',
    F: 'Female',

    //CURD Text
    CURD: {
      create: 'Create',
      edit: 'Edit',
      actions: 'Actions',
      update: 'Update',
      retrieve: 'Retrieve',
      delete: 'Delete',
      approve: 'Approve',
      reject: 'Reject',
      next: 'Next',
      complete: 'Complete',
      prev: 'Previous',
      deleteConfirmMessage: 'Confirm for deleting this record ?',
      save: 'Save',
      cancel:'Cancel'
    },
    workflow: {
      next: 'Next',
      previous: 'Previous',
      finish: 'Finish'
    },
    gender: 'Gender',
    dateOfBirth: 'Date of Birth',
    identityCardNo: 'ID Card No.',
    companyAddress: 'Company Address',
    correspondenceAddress: 'Correspondence Address',
    residentialAddress: 'Residential Address',
    chineseCompanyAddress: 'Company Address (Chinese)',
    chineseCorrespondenceAddress: 'Correspondence Address (Chinese)',
    chineseResidentialAddress: 'Residential Address (Chinese)',
    email: 'E-mail',
    fax: 'Fax',
    telephoneMobile: 'Mobile Phone',
    telephoneHome: 'Home',
    telephoneOffice: 'Office',
    processing: 'Processing',
  },
  kol:{
    title:'KOL Partner',
    footer:{
      homepage:'Home Page',
      shop:'My Shop',
      cart:'Cart',
      account:'Account',
      checkout: 'Checkout',
      orderList: 'My Order',
      addressList: 'Address List'
    },
  },
  home: homepage,
  auth,
  error,
  fitComponents,
   product,
  cart,
  account,
  payment,
}



// WEBPACK FOOTER //
// ./src/langs/en_us/index.js